module.exports = __webpack_public_path__ + "static/img/bg-en.fea12283.png";